import { RouteKeys } from 'types/types'
// NOTE: maybe it worth to use ENUM
export const handleIsSettingsRoute = (route: string) => {
  return (
    route === `/${RouteKeys.SiteDetails}` ||
    route === `/${RouteKeys.EquinomBins}` ||
    route === `/${RouteKeys.WheatCodes}` ||
    route === `/${RouteKeys.WheatProducts}` ||
    route === `/${RouteKeys.FlourProducts}` ||
    route === `/${RouteKeys.BakersProducts}` ||
    route === `/${RouteKeys.DeviceTypes}` ||
    route === `/${RouteKeys.DeviceSN}`
  )
}

export const handleIsFlourRoute = (route: string) => {
  return (
    route === `/${RouteKeys.Flours}` ||
    route === `/${RouteKeys.ProductionLine}` ||
    route === `/${RouteKeys.PostAging}` ||
    route.startsWith('/flours/')
  )
}

export const isObjectEmpty = (obj: Record<string, unknown>) => {
  return Object.keys(obj)?.length === 0
}

export const utilizeSilosData = (list, activeItemList) => {
  if (!list || !activeItemList) return []

  const checked = list?.map((listItem) => {
    if (activeItemList?.some((item) => item.id === listItem.id)) {
      return { ...listItem, active: true }
    }

    return { ...listItem, active: false }
  })

  return checked.sort(function (a, b) {
    return a.id - b.id
  })
}

export const sortByOrder = (arr) => {
  return arr?.sort((a, b) => a?.order > b?.order)
}

export const getFirstWords = (input: string, pivot: number | undefined = 5) => {
  if (typeof input !== 'string') return ''

  const words = input.split(' ')
  return words.slice(0, pivot).join(' ')
}
